// extracted by mini-css-extract-plugin
export default {"wrapper":"winCar_wrapper__UyZch"};